/**
 * Creates a scale validation function for scale value props.
 *
 * @param {Number} [defaultValue = 500] - The default value for this prop.
 * @param {Array.<Number>} validNumbers - An Array of valid scale numbers.
 *
 * @returns {Object}
 */
export default function (defaultValue, validNumbers) {
  const propConfig = {
    type: [Number, String],
    default: defaultValue,
  };

  if (import.meta.env.DEV) {
    if (!Array.isArray(validNumbers)) {
      throw new TypeError("'validNumbers' is not an array.");
    }

    if (typeof defaultValue !== 'number') {
      throw new TypeError("'defaultValue' is not a Number.");
    }

    propConfig.validator = function (value) {
      // Note, that validators are not triggered in production mode.
      return validNumbers.includes(Number.parseInt(value, 10));
    };
  }

  return propConfig;
}
